module.exports = __webpack_public_path__ + "img/mty.c1a6201a.jpeg";